export function captializeWords(string: string) {
  return string.replace(/\b./g, (letter) => letter.toUpperCase());
}
